
import React from 'react';
import {
    Avatar,
    Badge,
    Box,
    ButtonBase,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Fade,
    Grid,
    LinearProgress,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    makeStyles,
    Paper,
    Popper,
    Typography,
    useMediaQuery,
    useTheme
} from '@material-ui/core';

import PerfectScrollbar from 'react-perfect-scrollbar';

import { IconBell, IconBuildingStore } from '@tabler/icons';
import NotificationDataAccess, { NotificationGetAllRequestEntity, NotificationMarkReadRequestEntity } from '../../../../../DataAccess/NotificationDataAccess';
import { SessionHelper } from '../../../../../Core';
import { appendOlderNotifications, applyNotificationBatch, startAdminNotificationHub } from '../../../../../Core/AdminNotificationHub';
import { Notification, NotificationStatus } from '../../../../../Entity/Notification'




const useStyles = makeStyles((theme) => ({
    navContainer: {
        width: '100%',
        maxWidth: '330px',
        paddingTop: 0,
        paddingBottom: 0,
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '300px'
            //maxWidth: '100%'
        }
    },
    listAction: {
        top: '22px'
    },
    actionColor: {
        color: theme.palette.grey[500]
    },
    ScrollHeight: {
        height: '100%',
        maxHeight: 'calc(100vh - 205px)',
        overflowX: 'hidden'
    },
    listItem: {
        padding: 0
    },

    headerAvtar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.purple.light,
        color: theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.purple.dark,
        '&[aria-controls="menu-list-grow"],&:hover': {
            background: theme.palette.purple.main,
            color: theme.palette.purple.light
        }
    },
    cardContent: {
        padding: '0px !important'
    },
    notificationChip: {
        color: '#fff',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.warning.dark
    },
    divider: {
        marginTop: 0,
        marginBottom: 0
    },
    listDivider: {
        marginTop: 0,
        marginBottom: 0
    },
    listChipError: {
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
        height: '24px',
        padding: '0 6px',
        marginRight: '5px'
    },
    listChipWarning: {
        color: theme.palette.warning.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.warning.light,
        height: '24px',
        padding: '0 6px'
    },
    listChipSuccess: {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.success.light,
        height: '24px',
        padding: '0 6px'
    },
    listAvatarSuccess: {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.success.light,
        border: theme.palette.mode === 'dark' ? '1px solid' : 'none',
        borderColor: theme.palette.success.main
    },
    listAvatarPrimary: {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
        border: theme.palette.mode === 'dark' ? '1px solid' : 'none',
        borderColor: theme.palette.primary.main
    },
    listContainer: {
        paddingLeft: '56px'
    },
    uploadCard: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.purple.light
    },
    cardAction: {
        padding: '10px',
        justifyContent: 'center'
    },
    paddingBottom: {
        paddingBottom: '0'
    },
    box: {
        marginLeft: '16px',
        marginRight: '24px',
        [theme.breakpoints.down('sm')]: {
            marginRight: '16px'
        }
    },
    bodyspacing: {
        padding: '16px 16px 0'
    },
    textboxspacing: {
        padding: '0px 16px'
    },
    itemaction: {
        cursor: 'pointer',
        padding: '10px',
        '&:hover': {
            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
        }
    }
    // notificationpoper: {
    //     [theme.breakpoints.down('sm')]: {
    //         maxWidth: '100% ',
    //         //transform: 'none !important',
    //         top: '100% !important',
    //         left: '0px',
    //         right: '0px'
    //     }
    // }
}));

const _status = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'unread',
        label: 'unread'
    },
    {
        value: 'read',
        label: 'read'
    }
];

const NotificationSection = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down('sm'));

    const [open, setOpen] = React.useState(false);
    const [IsLoading, setIsLoading] = React.useState(false);
    const [NotificationList, setNotificationList] = React.useState([] as Notification[]);
    const isMounted = React.useRef(true);
    const loadingRef = React.useRef(false);
    const hasMoreRef = React.useRef(true);
    const listRef = React.useRef(NotificationList);
    const markingRef = React.useRef(new Set<string>());
    listRef.current = NotificationList;

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<Document> | React.TouchEvent<Document>) => {
        if (anchorRef.current && event.target instanceof Node && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current?.focus();
        }
        prevOpen.current = open;
    }, [open]);


    const pageSize = 100;

    const loadNotifications = React.useCallback(async (mode: 'initial' | 'older') => {
        if (loadingRef.current) {
            return;
        }
        if (mode === 'older' && (!hasMoreRef.current || listRef.current.length === 0)) {
            return;
        }

        const session = SessionHelper.GetSession();
        const rModel = new NotificationGetAllRequestEntity();
        rModel.AccessToken = session?.AccessToken ?? '';
        rModel.IsFullRefresh = false;
        rModel.ShowAll = false;
        if (mode === 'older') {
            rModel.LastNotificationId = listRef.current[listRef.current.length - 1].NotificationId;
        }

        loadingRef.current = true;
        setIsLoading(true);
        try {
            const res = await NotificationDataAccess.GetAllByAdminUserId(rModel);
            if (!isMounted.current) {
                return;
            }
            const page = res.Data ?? [];
            if (!res.IsSuccess && page.length === 0) {
                return;
            }
            hasMoreRef.current = page.length >= pageSize;
            setNotificationList(current => {
                if (mode === 'older') {
                    return appendOlderNotifications(current, page);
                }
                return applyNotificationBatch(page, current);
            });
        } catch {
            // The bell keeps whatever is already loaded if history cannot be fetched.
        } finally {
            loadingRef.current = false;
            if (isMounted.current) {
                setIsLoading(false);
            }
        }
    }, []);

    React.useEffect(() => {
        loadNotifications('initial');
    }, [loadNotifications]);

    React.useEffect(() => {
        const accessToken = SessionHelper.GetSession()?.AccessToken;
        if (!accessToken) {
            return;
        }

        const connection = startAdminNotificationHub(() => SessionHelper.GetSession()?.AccessToken || accessToken, batch => {
            if (!isMounted.current || batch.length === 0) {
                return;
            }
            setNotificationList(current => applyNotificationBatch(current, batch));
        });

        let disposed = false;
        connection.start().then(() => {
            if (disposed) {
                connection.stop();
            }
        }).catch(() => {
            // History still loads over HTTP when the hub is unreachable.
        });

        return () => {
            disposed = true;
            connection.stop();
        };
    }, []);

    React.useEffect(() => {
        if (!open) {
            return;
        }

        const session = SessionHelper.GetSession();
        const unread = listRef.current.filter(item => item.Status !== NotificationStatus.Read);
        unread.forEach(item => {
            if (!item.NotificationId || markingRef.current.has(item.NotificationId)) {
                return;
            }
            markingRef.current.add(item.NotificationId);
            const rModel = new NotificationMarkReadRequestEntity();
            rModel.NotificationId = item.NotificationId;
            rModel.AccessToken = session?.AccessToken ?? '';
            NotificationDataAccess.MarkRead(rModel).then(res => {
                markingRef.current.delete(item.NotificationId);
                if (!isMounted.current || !res.Data) {
                    return;
                }
                setNotificationList(current => applyNotificationBatch(current, [res.Data]));
            }).catch(() => {
                markingRef.current.delete(item.NotificationId);
            });
        });
    }, [open, NotificationList]);

    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setValue(event.target.value);
    // };


    var unreadMessageList = NotificationList.filter(i => i.Status !== NotificationStatus.Read)
    return (
        <React.Fragment>
            <Box component="span" className={classes.box}>
                <Badge
                    color="error"
                    badgeContent={unreadMessageList.length}
                    showZero={false}
                    max={999}
                    style={{ zIndex: 0, }}
                >
                    <ButtonBase
                        ref={anchorRef}
                        style={{ borderRadius: '12px' }}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                    >
                        <Avatar
                            variant="rounded"
                            className={classes.headerAvtar}
                        >
                            <IconBell stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </ButtonBase>
                </Badge>
            </Box>
            <Popper
                key="test"
                placement={matchesXs ? 'bottom' : 'bottom-end'}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal

                popperOptions={{
                    modifiers: {
                        offset: {
                            offset: '0, 10'
                        }
                    }
                }}
            >
                {({ TransitionProps, placement }) => (
                    <Fade {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <Card elevation={16}>
                                    <CardContent className={classes.cardContent}>
                                        <Grid container direction="column" spacing={2}>
                                            <Grid item xs={12}>
                                                <div className={classes.bodyspacing}>
                                                    <Grid container alignItems="center" justify="space-between">
                                                        <Grid item style={{ display: "flex", gap: 3, marginBottom: 10 }} >
                                                            <Typography variant="subtitle1">Notifications</Typography>
                                                            <Chip size="small"
                                                                label={NotificationList.length}
                                                                className={classes.notificationChip} />
                                                        </Grid>
                                                        {/* <Grid item>
                                                            <Link href="#">
                                                                <Typography variant="subtitle2" color="primary">
                                                                    Mark as all read
                                                                </Typography>
                                                            </Link>
                                                        </Grid> */}
                                                    </Grid>
                                                    <Grid item xs={12}   >
                                                        <Divider className={classes.divider} />
                                                        <LinearProgress color="secondary" hidden={!IsLoading} />
                                                    </Grid>
                                                </div>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <PerfectScrollbar
                                                    options={{
                                                        minScrollbarLength: 50
                                                    }}
                                                    className={classes.ScrollHeight}
                                                    onYReachEnd={() => { loadNotifications('older') }}

                                                >
                                                    <Grid container direction="column">
                                                        {/* <Grid item xs={12}>
                                                            <div className={classes.textboxspacing}>
                                                                <TextField
                                                                    id="outlined-select-currency-native"
                                                                    select
                                                                    fullWidth
                                                                    value={value}
                                                                    onChange={handleChange}
                                                                    SelectProps={{
                                                                        native: true
                                                                    }}
                                                                    variant="outlined"
                                                                >
                                                                    {status.map((option) => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </option>
                                                                    ))}
                                                                </TextField>
                                                            </div>
                                                        </Grid> */}
                                                        <Grid item xs={12}>
                                                            <List className={classes.navContainer} >
                                                                {NotificationList.map((item) => {
                                                                    return <React.Fragment key={item.NotificationId}>
                                                                        <div className={classes.itemaction}>
                                                                            <ListItem key={item.NotificationId} alignItems="center" className={classes.listItem}>
                                                                                <ListItemAvatar>
                                                                                    <Avatar className={classes.listAvatarSuccess}>
                                                                                        <IconBuildingStore />
                                                                                    </Avatar>
                                                                                </ListItemAvatar>
                                                                                <ListItemText
                                                                                    primary={
                                                                                        <Typography variant="subtitle1">{item.CreateBy}</Typography>
                                                                                    }
                                                                                />
                                                                                <ListItemSecondaryAction className={classes.listAction}>
                                                                                    <Grid container justify="flex-end">
                                                                                        <Grid item xs={12}>
                                                                                            <Typography
                                                                                                variant="caption"
                                                                                                display="block"
                                                                                                gutterBottom
                                                                                                className={classes.actionColor}
                                                                                            >{item.TimeAgo + " ago"}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </ListItemSecondaryAction>
                                                                            </ListItem>
                                                                            <Grid container direction="column" className={classes.listContainer}>
                                                                                <Grid item xs={12} className={classes.paddingBottom}>
                                                                                    <Typography variant="subtitle2">
                                                                                        {item.Message}
                                                                                    </Typography>
                                                                                </Grid>
                                                                                {/* <Grid item xs={12}>
                                                                                        <Grid container>
                                                                                            <Grid item>
                                                                                                <Chip
                                                                                                    label="Mark as read"
                                                                                                    onClick={() => { alert('This is marked as read') }}
                                                                                                    className={classes.listChipError}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item>
                                                                                                <Chip label="Show details" className={classes.listChipWarning} />
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid> */}
                                                                            </Grid>
                                                                        </div>
                                                                        <Divider className={classes.listDivider} />
                                                                    </React.Fragment>
                                                                })}
                                                            </List>
                                                        </Grid>
                                                    </Grid>
                                                </PerfectScrollbar>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <Divider />
                                    {/* <CardActions className={classes.cardAction}>
                                        <Button size="small" color="secondary" disableElevation>
                                            View All
                                        </Button>
                                    </CardActions> */}
                                </Card>
                            </ClickAwayListener>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </React.Fragment >
    );
};




export default NotificationSection;
